import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "sidebar-brand" }
const _hoisted_2 = { class: "sidebar-inner" }
const _hoisted_3 = { class: "icon-menu" }
const _hoisted_4 = { class: "bottom-menu" }

import type { PropType } from 'vue'
import { computed } from 'vue'
import AnimatedLogo from '../../../components/partials/AnimatedLogo.vue'
import { mapState } from "vuex";
type SidebarTheme =
  | 'default'
  | 'color'
  | 'color-curved'
  | 'curved'
  | 'float'
  | 'labels'
  | 'labels-hover'


export default /*@__PURE__*/_defineComponent({
  __name: 'Sidebar',
  props: {
  theme: {
    type: String as PropType<SidebarTheme>,
    default: 'default',
  },
  isOpen: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props
const themeClasses = computed(() => {
  switch (props.theme) {
    case 'color':
      return 'is-colored'
    case 'labels':
      return 'has-labels'
    case 'labels-hover':
      return 'has-labels-hover'
    case 'float':
      return !props.isOpen ? 'is-float' : 'is-float is-bordered'
    case 'curved':
      return !props.isOpen ? 'is-curved' : ''
    case 'color-curved':
      return !props.isOpen ? 'is-colored is-curved' : 'is-colored'
    default:
      return ''
  }
})
const user = computed(()=>{
  return mapState(['user'])
});

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (user.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["main-sidebar", [themeClasses.value]])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_RouterLink, { to: { name: 'Index' } }, {
            default: _withCtx(() => [
              _createVNode(AnimatedLogo, { width: "36px" })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_2, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "naver" }, null, -1)),
          _createElementVNode("ul", _hoisted_3, [
            _renderSlot(_ctx.$slots, "links")
          ]),
          _createElementVNode("ul", _hoisted_4, [
            _renderSlot(_ctx.$slots, "bottom-links")
          ])
        ])
      ], 2))
    : _createCommentVNode("", true)
}
}

})